<template>
  <!--合同区域--->
  <el-radio-group v-model="contractAreaCode">
    <el-radio :label="item.dictCode" v-for="(item,index) in contractAreaList" :key="index">{{item.dictName}}</el-radio>
  </el-radio-group>
  <!------------->
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-contractArea",
    data() {
      return {
        contractAreaList: [],
        contractAreaCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'CONTRACT_AREA',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.contractAreaList = res.data
        }
      })
    },
    watch: {
      contractAreaCode: function (currentVal) {
        this.$emit('contractAreaInfo', {contractAreaCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
